import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import NotificationDescription from "../Notifications/NotificationDescription";
import AntiRaggingPage from "../../containers/AntiRaggingPage";


const list = [
  {
    title: "Internal Complaints Committee",
    link: "/ugc-public-self-disclosure/icc",
    gr: "icc",
    type: 'UGC_ICC'
  },
  {
    title: "Student Grievance Redressal Committee",
    link: "/ugc-public-self-disclosure/sgrc",
    gr: "sgrc",
    type: 'UGC_SGRC'
  },
  {
    title: "Institutional Development Plans",
    link: "/ugc-public-self-disclosure/idp",
    type: 'UGC_IDP',
    gr: 'idp'
  },
  {
    title: "Accessibility Guidelines",
    link: "/ugc-public-self-disclosure/accessibility-guidelines",
    gr: 'accessibility-guidelines',
    type: 'UGC_ACCESSIBILITY_GUIDELINES'
  },
  {
    title: "Research & Development Cell",
    link: "/ugc-public-self-disclosure/research-development-cell",
    gr: 'research-development-cell',
    type: 'UGC_RESEARCH_DEVELOPMENT_CELL'
  },
  {
    title: "UGC Fee Refund Policy",
    link: "/ugc-public-self-disclosure/ugc-fee-refund-policy",
    gr: 'ugc-fee-refund-policy',
    type: 'UGC_FEE_REFUND_POLICY'
  },
   {
    title: "Anti-Ragging",
    link: "/ugc-public-self-disclosure/anti-ragging",
    gr: 'anti-ragging',
    type: 'UGC_ANTI_RAGGING'
  },
  {
    title: "Socio-Economically Disadvantaged Groups",
    link: "/ugc-public-self-disclosure/socio-economically-disadvantaged-groups",
    gr: 'socio-economically-disadvantaged-groups',
    type: 'UGC_SEDG'
  },
  {
    title: "Formal Undertaking",
    link: "/ugc-public-self-disclosure/formal-undertaking",
    gr: 'formal-undertaking',
    type: 'UGC_FORMAL_UNDERTAKING'
  }
];

class UgcComponent extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    const activeColor = "#0b5394";
    const accentColor = "#EBDB86";
    const activeItem = list.find((el) => el.gr === this.state.link);

    return (
      <div>
        <Container className="mb-4">
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "5em" }}
            >
              <Card
                style={{
                  border: "1px solid #e6e8eb",
                  borderRadius: "10px",
                  boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
                  overflow: "hidden",
                  position: "sticky",
                  top: "1rem",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    padding: "16px 20px",
                    background: `linear-gradient(135deg, ${activeColor} 0%, #1565c0 100%)`,
                    color: "#fff",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.72rem",
                      letterSpacing: "0.12em",
                      textTransform: "uppercase",
                      opacity: 0.85,
                      marginBottom: "4px",
                    }}
                  >
                    UGC Public Self-Disclosure
                  </div>
                  <div
                    style={{
                      fontSize: "1.05rem",
                      fontWeight: 600,
                      lineHeight: 1.3,
                    }}
                  >
                    Sections
                  </div>
                </div>

                <List component="nav" style={{ padding: 0 }}>
                  {list.map((el, index) => {
                    const isActive = el.gr === this.state.link;
                    return (
                      <ListItem
                        button
                        disableRipple
                        key={index}
                        onClick={() => this.props.history.push(el.link)}
                        style={{
                          borderBottom: "1px solid #eef0f3",
                          padding: "12px 16px 12px 18px",
                          borderLeft: isActive
                            ? `4px solid ${activeColor}`
                            : "4px solid transparent",
                          backgroundColor: isActive ? accentColor : "#fff",
                          transition:
                            "background-color 0.2s ease, border-color 0.2s ease",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.95rem",
                              fontWeight: isActive ? 600 : 500,
                              color: isActive ? "#1a1a1a" : "#3a4252",
                              lineHeight: 1.35,
                            }}
                          >
                            {el.title}
                          </span>
                          <ChevronRightIcon
                            style={{
                              fontSize: "1.1rem",
                              color: isActive ? activeColor : "#9aa3b2",
                              flexShrink: 0,
                            }}
                          />
                        </div>
                      </ListItem>
                    );
                  })}
                </List>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9} style={{ minHeight: "800px", paddingTop: "5em" }}>
              {activeItem ? (
                activeItem.gr === "anti-ragging" ? (
                  <AntiRaggingPage />
                ) : (
                  <NotificationDescription
                    key={activeItem.type}
                    code={activeItem.type}
                    title={activeItem.title}
                  />
                )
              ) : (
                <div
                  style={{
                    padding: "3rem 1rem",
                    textAlign: "center",
                    color: "#6b7280",
                    fontSize: "1rem",
                  }}
                >
                  Select a section from the sidebar to view its disclosures.
                </div>
              )}
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default UgcComponent;
